// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Sidebar · Ícones SVG outline estilo Lucide
// ═══════════════════════════════════════════════════════════════════
import React, { useState } from "react";
import { T, syne, mono, expandida } from "../../theme/tokens";
import { slaInfo } from "../../utils/formatters";
import { corFilial, filiaisDoUsuario, ufsDasFiliais } from "../../constants/filiais";
import { Icone, ICONES } from "../ui/Icone";

// Paths dos ícones por módulo
export const ICONS = {
  // Casa é a Início (#299); o Dashboard virou grade de painéis.
  inicio:          ["M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", "M9 22V12h6v10"],
  lubInicio:       ["M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", "M9 22V12h6v10"],
  dashboard:       ["M3 3h7v9H3z", "M14 3h7v5h-7z", "M14 12h7v9h-7z", "M3 16h7v5H3z"],
  notas:           ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M14 2v6h6", "M16 13H8", "M16 17H8", "M10 9H8"],
  // ReceiptText — cupom serrilhado com linhas de texto. O anterior era o
  // mesmo baú de caminhão usado em Transportadoras, com dois traços soltos:
  // dois módulos diferentes liam como a mesma coisa no menu.
  // Caixa com lupa — consulta de entrega (#371)
  consultaEntrega: ["M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
                    "M3.29 7L12 12l8.71-5", "M12 22V12", "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M21 22l-1.9-1.9"],
  tabelas:         ["M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z",
                    "M16 8H8", "M16 12H8", "M13 16H8"],
  conferencia:     ["M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", "M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2", "M9 12l2 2 4-4"],
  ocorrencias:     ["M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z", "M12 9v4", "M12 17h.01"],
  auditoria:       ["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", "M9 12l2 2 4-4"],
  analise:         ["M18 20V10", "M12 20V4", "M6 20v-6"],
  // Estes três estavam repetidos 3x (copiar/colar). Mantido o ícone que já
  // valia na prática — em objeto literal a ÚLTIMA chave repetida vence.
  compMunicipio:   ["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z", "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"],
  mapaOp:          ["M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z", "M8 2v16", "M16 6v16"],
  // Etiqueta com lápis ao lado — tabela fictícia (#380)
  simulacaoTabela: ["M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0l-8-8A2 2 0 0 1 2 11.2V4a2 2 0 0 1 2-2h7.2a2 2 0 0 1 1.4.6l8 8a2 2 0 0 1 0 2.8z",
                    "M7 7h.01", "M12 12l3 3"],
  comparativo:     ["M16 3h5v5", "M4 20L21 3", "M21 16v5h-5", "M15 15l5.1 5.1", "M4 4l5.1 5.1"],
  // Truck — cabine, baú e as duas rodas apoiadas na linha do chassi
  transportadoras: ["M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
                    "M15 18H9",
                    "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14",
                    "M17 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
                    "M7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"],
  clientes:        ["M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M23 21v-2a4 4 0 0 0-3-3.87", "M16 3.13a4 4 0 0 1 0 7.75"],
  municipios:      ["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z", "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"],
  usuarios:        ["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2", "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"],
  // Lâmpada (ideia/oportunidade) — usada no Painel de Oportunidades
  oportunidades:   ["M9 18h6", "M10 22h4", "M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V18h6v-1.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z"],

  // ── Faltavam no mapa e caíam no fallback ICONS.dashboard ──────────
  // Sem entrada aqui, o item da sidebar exibe a casinha do Dashboard — três
  // módulos diferentes com o mesmo ícone, o que quebra a leitura do menu.

  // Câmera — corpo com o ressalto do visor e a lente
  auditoriaFoto:   ["M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
                    "M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"],
  // Calendário com linhas de texto — relatório de um período
  relatorio:       ["M8 2v4", "M16 2v4",
                    "M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
                    "M3 10h18", "M8 14h8", "M8 18h5"],
  // Calendário limpo — datas marcadas, sem conteúdo
  feriados:        ["M8 2v4", "M16 2v4",
                    "M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
                    "M3 10h18"],
  // Relógio com seta de ajuste — revisão de prazo
  revisaoPrazos:   ["M12 21a9 9 0 1 0-8.5-6", "M3 21v-5h5", "M12 7v5l3 2"],
  // Etiqueta de preço — cotação de frete (também caía no fallback)
  cotacao:         ["M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0l-8-8A2 2 0 0 1 2 11.2V4a2 2 0 0 1 2-2h7.2a2 2 0 0 1 1.4.6l8 8a2 2 0 0 1 0 2.8z",
                    "M7 7h.01"],
  lubDashboard:    ["M3 3h7v7H3z", "M14 3h7v7h-7z", "M14 14h7v7h-7z", "M3 14h7v7H3z"],
  lubConferencia:  ["M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", "M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2", "M9 12l2 2 4-4"],
  lubCusto:        ["M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z", "M12 6v6l4 2"],
  // bandeira: divergência marcada para acompanhar até o desfecho (#195)
  divergencias:    ["M4 22V4", "M4 4h13l-2.5 4 2.5 4H4"],
  lubDivergencias: ["M4 22V4", "M4 4h13l-2.5 4 2.5 4H4"],
  // documento com check: CT-e da SEFAZ conferido (#194)
  cteSefaz:        ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M9 15l2 2 4-4"],
  lubCteSefaz:     ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M9 15l2 2 4-4"],
  lubMargem:       ["M18 20V10", "M12 20V4", "M6 20v-6"],
  lubGranel:       ["M3 3l1.5 15L12 21l7.5-3L21 3H3z", "M8 10h8", "M8 14h8"],
  lubOtif:         ["M22 12h-4l-3 9L9 3l-3 9H2"],
  lubComparativo:  ["M16 3h5v5", "M4 20L21 3", "M21 16v5h-5", "M15 15l5.1 5.1", "M4 4l5.1 5.1"],
  lubOportunidades:["M9 18h6", "M10 22h4", "M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V18h6v-1.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z"],
  lubOperacaoCWB:  ["M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"],
  lubOperacaoRBP:  ["M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"],
  lubCompMun:      ["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z", "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", "M8 21h8"],
  lubMapa:         ["M3 3h6v6H3z", "M15 3h6v6h-6z", "M15 15h6v6h-6z", "M3 15h6v6H3z", "M9 9h6v6H9z"],
  // Mesmos ícones do grupo Gamma — o menu do Lubpress lista os mesmos
  // conceitos e não faz sentido cada grupo desenhar tabela e transportadora
  // de um jeito.
  lubTabelas:      ["M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z",
                    "M16 8H8", "M16 12H8", "M13 16H8"],
  lubTransp:       ["M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
                    "M15 18H9",
                    "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14",
                    "M17 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
                    "M7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"],
  lubMunicipios:   ["M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z", "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"],
  lubClientes:     ["M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2", "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"],
  // Seta em L — representa o retorno (mercadoria volta pra Vibra)
  lubRetornoVibra: ["M9 14L4 9l5-5", "M20 20v-7a4 4 0 0 0-4-4H4"],
  // Rota — dois pontos conectados por um caminho (ícone "route" estilo Lucide)
  lubRotasVibra:   ["M4 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", "M20 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", "M4 17c0-6 4-6 4-10a2 2 0 1 1 4 0c0 4 8 4 8 10"],
  // Cifrão — tabela de tarifas
  lubTabelasVibra: ["M12 1v22", "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"],
};

// ── Menu por seção (#299) ─────────────────────────────────────────────
// Eram 17 itens num bloco só no grupo Gamma. Agrupados como no Risso Hub,
// cada um com a frase que a página Início mostra no atalho. A seção também
// vira o sobretítulo da tela ("— OPERAÇÕES"), lido por secaoDe().
const SECOES_GAMMA = [
  { nome:"Operações", itens:[
    { id:"notas",       label:"Notas Fiscais",      badge:true, desc:"Notas, embarques, previsão de entrega e transportadora de cada NF." },
    // todos:true — a única tela que o menu mostra a qualquer cargo (#371).
    { id:"consultaEntrega", label:"Consulta de Entrega", todos:true, desc:"Onde está a mercadoria de uma nota: rastreio, previsão e prazo." },
    { id:"conferencia", label:"Conferência",        desc:"Confere o frete cobrado de cada nota contra a tabela." },
    { id:"ocorrencias", label:"Ocorrências",        alert:true, desc:"Atrasos, devoluções, avarias e reclamações, até a solução." },
    { id:"cotacao",     label:"Cotação de Frete",   desc:"Compara o frete de uma carga em todas as tabelas cadastradas." },
  ]},
  { nome:"Auditoria", itens:[
    { id:"auditoria",     label:"Auditoria de Fatura", desc:"Importa a fatura da transportadora e aponta o que veio cobrado a mais." },
    { id:"divergencias",  label:"Divergências",        desc:"Acompanha cada cobrança a mais até o desconto ou a contestação." },
    { id:"cteSefaz",      label:"CT-e na SEFAZ",       desc:"CT-es emitidos contra a Gamma, direto da SEFAZ." },
    { id:"auditoriaFoto", label:"Auditoria por Foto",  desc:"Lê os recibos fotografados e confere com as notas." },
  ]},
  { nome:"Análise", itens:[
    { id:"dashboard",     label:"Dashboard",          desc:"OTIF, volume e frete do período, por filial e transportadora." },
    { id:"analise",       label:"Análise Geral",      desc:"Indicadores por transportadora, cliente e município." },
    { id:"relatorio",     label:"Relatório Mensal",   desc:"Entregue × pendente e OTIF do mês, com PDF e Excel." },
    { id:"revisaoPrazos", label:"Revisão de Prazos",  desc:"Prazos cadastrados que não batem com as entregas reais." },
    { id:"oportunidades", label:"Oportunidades",      desc:"Onde trocar de transportadora reduziria o frete." },
    { id:"comparativo",   label:"Comparativo",        desc:"Simula outra tabela sobre as notas de uma transportadora." },
    { id:"simulacaoTabela", label:"Simulação de Tabela", desc:"Monta uma tabela fictícia e compara com as cadastradas para uma carga." },
    { id:"compMunicipio", label:"Comp. Município",    desc:"Compara transportadoras para as rotas escolhidas." },
    { id:"mapaOp",        label:"Mapa Operacional",   desc:"Frete, volume e atrasos pintados por município." },
  ]},
  { nome:"Cadastros", itens:[
    { id:"tabelas",         label:"Tabelas de Frete", desc:"Tabelas por transportadora, vigência e município." },
    { id:"transportadoras", label:"Transportadoras",  desc:"Códigos, nomes e filial de cada transportadora." },
    { id:"clientes",        label:"Clientes",         desc:"Clientes, tipo e transportadora de cada um." },
    { id:"municipios",      label:"Municípios",       desc:"Transportadora e prazo padrão de cada município." },
    { id:"feriados",        label:"Feriados",         desc:"Feriados que entram no cálculo de dias úteis." },
    { id:"usuarios",        label:"Usuários",         desc:"Perfil, convites e cargos de quem usa o sistema." },
  ]},
];

const SECOES_LUBPRESS = [
  { nome:"Operação", itens:[
    { id:"lubOperacaoCWB",  label:"Operação — Curitiba", desc:"Remessas do dia em Curitiba: romaneio, embarque e etiquetas." },
    { id:"lubOperacaoRBP",  label:"Operação — Ribeirão", desc:"Remessas do dia em Ribeirão Preto: romaneio, embarque e etiquetas." },
    { id:"lubConferencia",  label:"Conferência CT-e",    desc:"Confere a receita dos CT-es emitidos para a Vibra." },
    { id:"lubRetornoVibra", label:"Retorno Vibra",       desc:"Retorno de armazenagem: saldo das NFs e confirmação." },
    { id:"lubCusto",        label:"Custo Prestadores",   desc:"CT-es dos prestadores, custo e auditoria de fatura." },
  ]},
  { nome:"Auditoria", itens:[
    { id:"lubDivergencias", label:"Divergências",        desc:"Cobranças a mais dos prestadores, até o desfecho." },
    { id:"lubCteSefaz",     label:"CT-e na SEFAZ",       desc:"CT-es emitidos contra a Lubpress, direto da SEFAZ." },
  ]},
  { nome:"Análise", itens:[
    { id:"lubDashboard",    label:"Dashboard Vibra",     desc:"Receita, custo, margem e OTIF da operação Vibra." },
    { id:"lubMargem",       label:"Margem",              desc:"Receita Vibra contra custo dos prestadores, por CT-e." },
    { id:"lubOtif",         label:"OTIF",                desc:"Prazo por prestador, com a meta contratual." },
    { id:"lubComparativo",  label:"Comparativo",         desc:"Margem de cada prestador para uma carga." },
    { id:"lubCompMun",      label:"Comp. por Município", desc:"Margem por município e prestador." },
    { id:"lubOportunidades",label:"Oportunidades",       desc:"Onde trocar de prestador aumentaria a margem." },
    { id:"lubMapa",         label:"Mapa Operacional",    desc:"Margem por rota e estado." },
  ]},
  { nome:"Configurações", itens:[
    { id:"lubGranel",       label:"Granel",              desc:"Volume de granel por rota e mínimo mensal." },
    { id:"lubTabelas",      label:"Tabelas de Frete",    desc:"Tabelas dos prestadores." },
    { id:"lubRotasVibra",   label:"Rotas Vibra",         desc:"Rota e SLA de cada cidade atendida." },
    { id:"lubTabelasVibra", label:"Tabelas Vibra",       desc:"Tarifas cobradas da Vibra por rota." },
    { id:"lubTransp",       label:"Transportadoras",     desc:"Prestadores da Lubpress." },
    { id:"lubMunicipios",   label:"Municípios",          desc:"Filial, transportadora e prazos por município." },
    { id:"lubClientes",     label:"Clientes",            desc:"Clientes da Vibra, paletização e coordenadas." },
    { id:"lubNotas",        label:"Notas Fiscais",       desc:"NFs da Vibra e OTIF duplo (contrato e transportadora)." },
    { id:"lubProdutos",     label:"Produtos (SB1)",      desc:"Cadastro de produtos." },
  ]},
];

export const SECOES = { gamma: SECOES_GAMMA, lubpress: SECOES_LUBPRESS };
const INICIO = { gamma:"inicio", lubpress:"lubInicio" };

// Seção de uma tela, para o sobretítulo. A Início não tem seção.
export function secaoDe(id) {
  for (const g of Object.values(SECOES))
    for (const s of g) if (s.itens.some(i => i.id === id)) return s.nome;
  return null;
}

// Telas de cada grupo e a que abre primeiro. A tela pedida na URL é
// conferida contra esta lista (#214): o menu é a fonte de quais telas existem.
// A Início abre primeiro desde a #299; antes era Notas e Operação Curitiba.
const idsDe = (g) => [INICIO[g], ...SECOES[g].flatMap(s => s.itens.map(i => i.id))];
export const TELAS = {
  gamma:    { inicial:"inicio",    ids:idsDe("gamma") },
  lubpress: { inicial:"lubInicio", ids:idsDe("lubpress") },
};

// ── Telas por cargo (#315) ────────────────────────────────────────────
// Administrador e gestor veem tudo; operacional, a Início e a primeira
// seção, que nos dois grupos é a de operação; qualquer outro cargo, a Início
// e as telas marcadas `todos` (a Consulta de Entrega, #371). Na Lubpress, a
// operação de uma cidade some para quem não tem acesso ao estado dela. A
// restrição é de tela: os dados continuam chegando ao navegador (ver a #315).
const UF_DA_OPERACAO = { lubOperacaoCWB:"PR", lubOperacaoRBP:"SP" };
export function secoesDe(grupo, usuario) {
  const cargo = usuario?.cargo;
  const todas = SECOES[grupo];
  const secoes = cargo === "admin" || cargo === "gestor" ? todas
    : cargo === "operacional" ? todas.slice(0, 1)
    : todas.map(s => ({ ...s, itens: s.itens.filter(i => i.todos) })).filter(s => s.itens.length);
  const cidades = filiaisDoUsuario(usuario);
  if (!cidades) return secoes;
  const ufs = ufsDasFiliais(cidades);
  return secoes.map(s => ({ ...s,
    itens: s.itens.filter(i => !UF_DA_OPERACAO[i.id] || ufs.includes(UF_DA_OPERACAO[i.id])) }));
}

// O que useNavegacao aceita na URL: as telas do cargo, e não as do grupo.
export const telasDe = (grupo, usuario) => ({
  inicial: INICIO[grupo],
  ids: [INICIO[grupo], ...secoesDe(grupo, usuario).flatMap(s => s.itens.map(i => i.id))],
});


// O menu lembra se ficou recolhido. try/catch: o navegador pode negar o
// armazenamento (janela anônima), e o menu tem de abrir mesmo assim.
const CHAVE_RECOLHIDO = "tms_menu_recolhido";
function lerRecolhido() {
  try { return localStorage.getItem(CHAVE_RECOLHIDO) === "1"; } catch { return false; }
}
function gravarRecolhido(v) {
  try { localStorage.setItem(CHAVE_RECOLHIDO, v ? "1" : "0"); } catch { /* sem armazenamento */ }
}

// ── Animação de recolher (#310) ───────────────────────────────────────
// Travava por dois motivos. (1) Os nomes, os títulos de seção e o seletor
// de filial saíam da tela de uma vez no clique, os ícones pulavam do canto
// para o centro e a lista inteira subia: o salto acontecia antes de a
// largura começar a animar. Agora nada muda de lugar dentro do menu: os
// ícones ficam sempre a 24px da borda, os textos só somem (opacidade) e
// são cortados pela largura, e os títulos guardam a altura. (2) A largura
// animava dentro do fluxo da página, que era redesenhada a cada quadro.
// Agora o menu anima por cima do conteúdo, e a página se ajusta uma vez.
const DURACAO = "var(--m-amplo) var(--m-estado)";
const some = (oculto) => ({
  opacity: oculto ? 0 : 1,
  transition: oculto ? "opacity var(--m-rapido) var(--m-entrada-seca)" : "opacity var(--m-base) var(--m-saida-suave) 60ms",
  whiteSpace: "nowrap",
});

function NavItem({ item, active, onClick, collapsed, nfIncorr, urgN, cor }) {
  const [h, setH] = useState(false);
  const isA   = active === item.id;
  const badge = item.badge ? nfIncorr : item.alert ? urgN : 0;

  return (
    <button type="button" onClick={() => onClick(item.id)}
      title={collapsed ? item.label : undefined}
      /* Recolhido, o item fica só com o ícone SVG e perde o nome. O
         aria-label vale nos dois estados; aria-current diz qual tela está
         aberta, que hoje só a cor informa (#94). */
      aria-label={item.label}
      aria-current={isA ? "page" : undefined}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      style={{
        width:"100%", position:"relative",
        display:"flex", alignItems:"center", gap:10,
        padding:"4px 8px",
        border:"none", borderRadius:10,
        background: isA ? T.text + "0d" : h ? T.text + "08" : "transparent",
        color: isA || h ? T.text : T.sub,
        fontSize:13, fontWeight: isA ? 700 : 500,
        cursor:"pointer", transition:"var(--m-cor)",
        marginBottom:2, textAlign:"left", ...syne,
      }}>
      {isA && (
        <span aria-hidden="true" style={{ position:"absolute", left:-14, top:8, bottom:8,
          width:3, borderRadius:2, background:cor }}/>
      )}

      <span style={{ width:32, height:32, borderRadius:8, flexShrink:0,
        display:"inline-flex", alignItems:"center", justifyContent:"center",
        background: isA ? cor : "transparent", transition:"var(--m-cor)" }}>
        <Icone d={ICONS[item.id] || ICONS.inicio} size={17}
          color={isA ? "#fff" : "currentColor"} strokeWidth={isA ? 2 : 1.7}/>
      </span>

      <span style={{ flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", ...some(collapsed) }}>
        {item.label}
      </span>

      {/* Recolhido, o selo vai para o canto do quadrado do ícone, menor e
          com um anel da cor do fundo; os 80px do menu cabem o "999+" (#313). */}
      {badge > 0 && (
        <span style={{
          fontSize:10.5, fontWeight:700, padding:"1px 6px", borderRadius:99,
          background:T.red, color:"#fff", ...mono,
          ...(collapsed ? { position:"absolute", top:-1, left:30, fontSize:9, padding:"0 4px",
            lineHeight:"14px", boxShadow:`0 0 0 2px ${T.surface}` } : {}),
        }}>
          {badge > 999 ? "999+" : badge}
        </span>
      )}
    </button>
  );
}

// Função: T muda com o tema e é lido na hora (#216).
const rotuloSecao = () => ({
  fontSize:10.5, fontWeight:700, color:T.muted, textTransform:"uppercase",
  letterSpacing:".1em", padding:"14px 10px 6px", ...syne,
});

// Título de seção com altura fixa: recolhido, o texto some e uma linha
// aparece no mesmo lugar, sem a lista mudar de altura. O texto fica rente
// ao grupo que abre (mais folga em cima que embaixo). Recolhido, o bloco
// encolhe para a própria linha: os ícones de cima e de baixo ficam quase à
// distância de dois ícones vizinhos, e a lista anima a altura junto (#373).
function TituloSecao({ nome, collapsed }) {
  return (
    <div style={{ ...rotuloSecao(), position:"relative", height: collapsed ? 3 : 28, boxSizing:"border-box",
      display:"flex", alignItems:"flex-end", padding: collapsed ? "0 10px" : "0 10px 4px", overflow:"hidden",
      transition:`height ${DURACAO}, padding ${DURACAO}` }}>
      <span style={some(collapsed)}>{nome}</span>
      <span aria-hidden="true" style={{ position:"absolute", left:8, top:0, width:32, height:1,
        background:T.border, opacity: collapsed ? 1 : 0, transition:`opacity ${DURACAO}` }}/>
    </div>
  );
}

// ── Sidebar principal ─────────────────────────────────────────────────
function Sidebar({ active, onNav, filial, onFilial, ocorrencias, nfIncorr, grupo, onTrocarGrupo,
                   usuario, gaveta = false, aberta = false, onFechar }) {
  const isLubpress = grupo === "lubpress";
  const cor = isLubpress ? T.purple : T.red;
  const [recolhidoSalvo, setCollapsedState] = useState(lerRecolhido);
  // Na gaveta (tela estreita) o menu abre sempre inteiro: recolhido, ele
  // seria uma faixa de ícones por cima do conteúdo (#305).
  const collapsed = gaveta ? false : recolhidoSalvo;
  const setCollapsed = (v) => { setCollapsedState(v); gravarRecolhido(v); };
  const urgN   = (ocorrencias||[]).filter(o => {
    try { return slaInfo(o)?.tipo === "urgente"; } catch { return false; }
  }).length;
  const filCor = corFilial(filial);
  const W      = collapsed ? 80 : 240;

  // Esc fecha a gaveta, como o toque no fundo escurecido.
  React.useEffect(() => {
    if (!gaveta || !aberta) return undefined;
    const f = (e) => { if (e.key === "Escape") onFechar?.(); };
    window.addEventListener("keydown", f);
    return () => window.removeEventListener("keydown", f);
  }, [gaveta, aberta, onFechar]);
  const secoes = secoesDe(isLubpress ? "lubpress" : "gamma", usuario);
  // Com filiais de acesso (#315), o seletor só oferece as permitidas, e o
  // "todos" passa a ser "as minhas" — o App filtra por elas.
  const cidades = filiaisDoUsuario(usuario);
  const minhas  = cidades && (isLubpress ? ufsDasFiliais(cidades) : cidades);
  const inicio = { id: INICIO[isLubpress ? "lubpress" : "gamma"], label:"Início" };
  // Escolher uma tela recolhe o menu (#310): aberto, ele só serve para
  // escolher, e depois toma 240px da tela. O Início é a exceção e abre o
  // menu, que ali é o ponto de partida (#313). Na gaveta quem fecha é o App.
  //
  // A tela nova abre numa transição (useNavegacao), e `active` só muda
  // depois que ela montou. Recolher no clique animava a largura com a
  // página sendo montada: travava, e a marca da tela chegava por último.
  // Agora o item escolhido marca na hora e o menu recolhe quando a tela
  // nova já está no lugar (#313).
  const [escolhido, setEscolhido] = useState(null);
  const escolher = (id) => {
    if (onNav(id) !== false) setEscolhido(id);
  };
  React.useEffect(() => {
    if (escolhido === null || active !== escolhido) return;
    setEscolhido(null);
    if (!gaveta) setCollapsed(active !== inicio.id);
  }, [active, escolhido]);
  const item = (it) => (
    <NavItem key={it.id} item={it} active={escolhido ?? active} onClick={escolher} cor={cor}
      collapsed={collapsed} nfIncorr={nfIncorr} urgN={urgN}/>
  );

  const seletorFilial = { width:"100%", background:T.card,
    border:`1px solid ${filial==="todos" ? T.border : filCor+"66"}`,
    borderRadius:8, padding:"7px 9px",
    color: filial==="todos" ? T.text : filCor,
    fontSize:12.5, outline:"none", cursor:"pointer", fontWeight:600, ...syne };

  const menu = (
    <aside aria-hidden={gaveta && !aberta ? true : undefined}
      style={gaveta ? {
        width:272, background:T.surface, borderRight:`1px solid ${T.border}`,
        display:"flex", flexDirection:"column", height:"100vh",
        position:"fixed", top:0, left:0, zIndex:300,
        transform: aberta ? "none" : "translateX(-100%)",
        visibility: aberta ? "visible" : "hidden",
        boxShadow: aberta ? "0 0 40px rgba(0,0,0,.45)" : "none",
        transition:"transform var(--m-amplo) var(--m-ios), visibility var(--m-amplo)",
        overflow:"hidden",
      } : {
        // Por cima do conteúdo: quem ocupa o lugar na página é o invólucro
        // abaixo, que muda de largura de uma vez.
        width:W, background:T.surface, borderRight:`1px solid ${T.border}`,
        display:"flex", flexDirection:"column", height:"100vh",
        position:"absolute", top:0, left:0, zIndex:150,
        transition:`width ${DURACAO}`, willChange:"width",
        overflow:"hidden",
      }}>

      {/* ── Logo ──────────────────────────────────────────────────── */}
      <div style={{
        height:56, flexShrink:0,
        display:"flex", alignItems:"center", gap:10,
        padding:"0 23px",
        borderBottom:`1px solid ${T.border}`,
      }}>
        <img src="/logo.png" alt="Gamma TMS"
          style={{ width:34, height:34, borderRadius:8, objectFit:"contain", flexShrink:0 }}/>
        <div style={{ minWidth:0, ...some(collapsed) }}>
          <div style={{ fontSize:15, ...expandida, letterSpacing:".02em", lineHeight:1.1 }}>GAMMA TMS</div>
          <div style={{ fontSize:11, color: cor, fontWeight:700, ...syne }}>
            {isLubpress ? "Lubpress" : "Gamma"}
          </div>
        </div>
      </div>

      {/* ── Recolher/expandir, como o "☰ MENU" do Risso Hub. Na gaveta,
             o mesmo botão fecha (#305). ────────────────────────────── */}
      <button type="button" onClick={() => gaveta ? onFechar?.() : setCollapsed(!collapsed)}
        aria-label={gaveta ? "Fechar menu" : collapsed ? "Expandir menu" : "Recolher menu"}
        title={gaveta ? "Fechar menu" : collapsed ? "Expandir menu" : "Recolher menu"} aria-expanded={!collapsed}
        style={{ display:"flex", alignItems:"center", gap:10, flexShrink:0,
          margin:"10px 10px 0 16px", padding:"6px 8px",
          background:"none", border:"none", borderRadius:8, cursor:"pointer",
          color:T.sub, fontSize:11, fontWeight:700, letterSpacing:".12em", ...syne }}
        onMouseEnter={e => { e.currentTarget.style.background = T.text + "08"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "none"; }}>
        <span style={{ width:32, height:32, flexShrink:0, display:"inline-flex", alignItems:"center", justifyContent:"center" }}>
          <Icone d={gaveta ? ICONES.fechar : ["M3 6h18", "M3 12h18", "M3 18h18"]} size={18}/>
        </span>
        <span style={some(collapsed)}>MENU</span>
      </button>

      {/* ── Seletor de filial — Gamma tem 5 filiais, Lubpress tem 2 ──
          Recolhido, o bloco encolhe para a faixa da cor da filial: a
          altura anima junto com a largura, sem a lista saltar. */}
      {/* Recolhido e sem filial escolhida, o bloco some: não sobra vão entre
          o botão do menu e a casinha do Início (#373). */}
      <div style={{ flexShrink:0, position:"relative", overflow:"hidden", boxSizing:"border-box",
        height: !collapsed ? 70 : filial !== "todos" ? 14 : 0,
        padding: collapsed ? "0 14px" : "8px 14px 0",
        transition:`height ${DURACAO}, padding ${DURACAO}` }}>
        <div style={{ width:212, ...some(collapsed), visibility: collapsed ? "hidden" : "visible" }}>
          <div style={{ ...rotuloSecao(), padding:"0 0 5px" }}>Filial</div>
          {minhas ? (
            <select value={filial} onChange={e => onFilial(e.target.value)} aria-label="Filial"
              tabIndex={collapsed ? -1 : 0} style={seletorFilial}>
              <option value="todos">{minhas.length > 1 ? "Minhas filiais" : minhas[0]}</option>
              {minhas.length > 1 && minhas.map(f => <option key={f} value={f}>{f}</option>)}
            </select>
          ) : isLubpress ? (
            // Lubpress: apenas PR (Curitiba) e SP (Ribeirão Preto)
            <select value={filial} onChange={e => onFilial(e.target.value)} aria-label="Filial"
              tabIndex={collapsed ? -1 : 0} style={seletorFilial}>
              <option value="todos">Todas as Filiais</option>
              <option value="PR">PR — Curitiba</option>
              <option value="SP">SP — Ribeirão Preto</option>
            </select>
          ) : (
            // Gamma: 5 filiais completas
            <select value={filial} onChange={e => onFilial(e.target.value)} aria-label="Filial"
              tabIndex={collapsed ? -1 : 0} style={seletorFilial}>
              <option value="todos">Visualizar Todos</option>
              <option disabled>──── PR ────────────</option>
              <option value="PR">Visualizar PR</option>
              <option value="Curitiba">    Curitiba</option>
              <option value="Maringá">    Maringá</option>
              <option value="Cascavel">    Cascavel</option>
              <option disabled>──── SP ────────────</option>
              <option value="SP">Visualizar SP</option>
              <option value="Ribeirão Preto">    Ribeirão Preto</option>
              <option value="Marília">    Marília</option>
            </select>
          )}
        </div>
        {filial !== "todos" && (
          <div title={filial} style={{ position:"absolute", left:28, top:6, width:24, height:3,
            borderRadius:2, background:filCor, opacity: collapsed ? 1 : 0, transition:`opacity ${DURACAO}` }}/>
        )}
      </div>

      {/* ── Navegação por seção ─────────────────────────────────────── */}
      {/* Recolhido, rola sem barra: a barra comia a faixa do selo (#313). */}
      <nav aria-label="Menu" style={{ flex:1, padding:"6px 10px 10px 16px", overflowY:"auto", overflowX:"hidden",
        scrollbarWidth: collapsed ? "none" : undefined }}>
        {item(inicio)}
        {secoes.map(sec => (
          <div key={sec.nome}>
            <TituloSecao nome={sec.nome} collapsed={collapsed}/>
            {sec.itens.map(item)}
          </div>
        ))}
      </nav>

      {/* ── Trocar grupo ────────────────────────────────────────────── */}
      {onTrocarGrupo && (
        <div style={{ padding:"8px 10px", borderTop:`1px solid ${T.border}`, flexShrink:0 }}>
          <button type="button" onClick={onTrocarGrupo}
            title={collapsed ? `${isLubpress ? "Lubpress" : "Gamma"} — trocar grupo` : undefined}
            aria-label={`Trocar grupo (agora ${isLubpress ? "Lubpress" : "Gamma"})`}
            style={{ width:"100%", background:"transparent",
              border:`1px solid ${collapsed ? "transparent" : T.border}`,
              borderRadius:8, padding: collapsed ? "7px 0" : "7px 0 7px 26px", cursor:"pointer",
              color:T.sub, fontSize:12, fontWeight:600, overflow:"hidden",
              display:"flex", alignItems:"center", justifyContent: collapsed ? "center" : "flex-start",
              gap:7, transition:`border-color ${DURACAO}`, ...syne }}>
            {/* Recolhido, o nome do sistema ocupa o lugar do ponto: diz se
                se está no Gamma ou na Lubpress (#373). */}
            {!collapsed && <span style={{ width:8, height:8, borderRadius:"50%", background:cor, flexShrink:0 }}/>}
            <span style={collapsed ? { color:cor, fontSize:10.5, fontWeight:700 } : { color:T.text }}>
              {isLubpress?"Lubpress":"Gamma"}
            </span>
            {!collapsed && <span style={{ marginLeft:"auto", paddingRight:10 }}>Trocar grupo</span>}
          </button>
        </div>
      )}

    </aside>
  );

  if (gaveta) return menu;
  // Invólucro que ocupa o lugar do menu na página. Muda de largura de uma
  // vez, e o menu anima por cima dele (#310).
  return (
    <div style={{ width:W, flexShrink:0, height:"100vh", position:"relative" }}>
      {menu}
    </div>
  );
}

export default Sidebar;
